import { getDomainValue } from 'utils/domain';

export const GTM_COMMON_ID = 'GTM-WZW3WRJ7';

export const GMT_DOMAIN_ID = getDomainValue({
  camper: 'GTM-TTHX9KP',
  nnormal: 'GTM-KHCX5VN',
  camperlab: 'GTM-KBZBFDGG',
});
